export const VaultsLegacy = {
  BONDED: [
    {
      chainId: 1,
      name: 'Bonded_NTX',
      type: 'BONDED',
      poolId: 0,
      poolAddress: '0x502b965d3d51d4fd531e6a1c1fa9bfa50337ba55',
      tokensLocked: '12487709.737003',
      totalValueLockedUSD: '154344.97',
      active: false,
      status: 'CLOSED',
      tokens: ['NTX'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Bonded_SDAO',
      type: 'BONDED',
      poolId: 0,
      poolAddress: '0x74641ed232dbB8CBD9847484dD020d44453F0368',
      tokensLocked: '1684546.392657889146676573',
      totalValueLockedUSD: '81180.94',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Bonded_SDAO_2',
      type: 'BONDED',
      poolId: 0,
      poolAddress: '0xF5738B4aD2f8302b926676692a0C09603d930b42',
      tokensLocked: '1103775.730517470965774859',
      totalValueLockedUSD: '53192.69',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Bonded_SDAO_BSC',
      type: 'BONDED',
      poolId: 0,
      poolAddress: '0x17de46760F4c18C26eEc36117C23793299F564A8',
      tokensLocked: '642335.87429851493266584',
      totalValueLockedUSD: '30955.17',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO'],
      averageAPR: '0',
    },
  ],
  UNBONDED: [
    {
      chainId: 1,
      name: 'Unbonded_SDAO',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '5044258.324500541035210971',
      totalValueLockedUSD: '243090.73',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_NTX',
      type: 'UNBONDED',
      poolId: 1,
      poolAddress: '0xb267DeaACe0B8c5FcB2bb04801A364e7Af7DA3F4',
      tokensLocked: '20171653.777073',
      totalValueLockedUSD: '249316.60',
      active: false,
      status: 'CLOSED',
      tokens: ['NTX'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_AGIX',
      type: 'UNBONDED',
      poolId: 7,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '587927.00223988',
      totalValueLockedUSD: '176229.94',
      active: false,
      status: 'CLOSED',
      tokens: ['AGIX'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_RJV',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x5caDCF74A14a6aa67e95E418625b82831b241b58',
      tokensLocked: '5679698.087749',
      totalValueLockedUSD: '32487.13',
      active: false,
      status: 'CLOSED',
      tokens: ['RJV'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_HYPC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xd1061Ff97c34835B90E3f8080e3AE2e5C8B38f1D',
      tokensLocked: '1155567.888306',
      totalValueLockedUSD: '45974.57',
      active: false,
      status: 'CLOSED',
      tokens: ['HYPC'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_SOPH',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xCe99861F0244D6478a309e2c2565FDaaAA8b0bFb',
      tokensLocked: '5397525.209473566088893963',
      totalValueLockedUSD: '23053.80',
      active: false,
      status: 'CLOSED',
      tokens: ['SOPH'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_CGV',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x31Cd039D37DEe0C989cbE390F668fc38b033fB4f',
      tokensLocked: '24448.119211',
      totalValueLockedUSD: '185.10',
      active: false,
      status: 'CLOSED',
      tokens: ['CGV'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_SDAO_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x79292c62F593E08d9b850b790b07E7a0903fD007',
      tokensLocked: '1217332.220943190406206535',
      totalValueLockedUSD: '59463.84',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO'],
      averageAPR: '0',
    },
    {
      chainId: 8453,
      name: 'Unbonded_SKYA_Base',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x8a7f47da04911307C0AbA48E48BC4E3165bA976f',
      tokensLocked: '145246.801636328137100846',
      totalValueLockedUSD: '689.27',
      active: false,
      status: 'CLOSED',
      tokens: ['SKYA'],
      averageAPR: '0',
    },
    {
      chainId: 8453,
      name: 'Unbonded_SOPH_Base',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '8203784.05681596694797002',
      totalValueLockedUSD: '35453.64',
      active: false,
      status: 'CLOSED',
      tokens: ['SOPH'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_RJV_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x738A23A889a6257Ea8678803e4b8Db9605D63B9C',
      tokensLocked: '3591463.610012',
      totalValueLockedUSD: '20814.00',
      active: false,
      status: 'CLOSED',
      tokens: ['RJV'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_CGV_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xB9892Aed8E49bf167Eb15D269777F6F5850aE450',
      tokensLocked: '5435124.538795',
      totalValueLockedUSD: '41149.27',
      active: false,
      status: 'CLOSED',
      tokens: ['CGV'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_SOPH_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0xD8912300C2b96d9F2fb8f4a9cFea351Ebe2A696E',
      tokensLocked: '3055253.193274707949542216',
      totalValueLockedUSD: '13049.35',
      active: false,
      status: 'CLOSED',
      tokens: ['SOPH'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_HYPC_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x158a1d0144D8e5449305435DFaDEe07cd2dC85F4',
      tokensLocked: '46371.492135',
      totalValueLockedUSD: '1870.98',
      active: false,
      status: 'CLOSED',
      tokens: ['HYPC'],
      averageAPR: '0',
    },
    {
      chainId: 1,
      name: 'Unbonded_SKYA',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x7Cc63D9D3Db18d4244c2F0eFd0Ca6fed605d83Fe',
      tokensLocked: '1988480.912715003453745666',
      totalValueLockedUSD: '9126.13',
      active: false,
      status: 'CLOSED',
      tokens: ['SKYA'],
      averageAPR: '0',
    },
    {
      chainId: 56,
      name: 'Unbonded_RJVOLD_BSC',
      type: 'UNBONDED',
      poolId: 0,
      poolAddress: '0x93192A62008E25c33CBC3e60A00D27736b7b423F',
      tokensLocked: '198036.110483',
      totalValueLockedUSD: '1132.83',
      active: false,
      status: 'CLOSED',
      tokens: ['RJV'],
      averageAPR: '0',
    },
  ],
  YIELD: [
    {
      chainId: 1,
      name: 'Yield_RJV_ETH',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x5caDCF74A14a6aa67e95E418625b82831b241b58',
      tokensLocked: '11327343.589885',
      totalValueLockedUSD: '125412.51',
      active: true,
      status: 'OPEN',
      tokens: ['RJV', 'ETH'],
      averageAPR: '27.3648',
    },
    {
      chainId: 56,
      name: 'Yield_RJV_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x738A23A889a6257Ea8678803e4b8Db9605D63B9C',
      tokensLocked: '11530345.759553',
      totalValueLockedUSD: '133107.01',
      active: true,
      status: 'OPEN',
      tokens: ['RJV', 'BNB'],
      averageAPR: '39.3050',
    },
    {
      chainId: 8453,
      name: 'Yield_SKYA_ETH_Base',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x8a7f47da04911307C0AbA48E48BC4E3165bA976f',
      tokensLocked: '14211993.023846180759929776',
      totalValueLockedUSD: '130092.92',
      active: true,
      status: 'OPEN',
      tokens: ['SKYA', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_NTX_ETH_V2',
      type: 'YIELD',
      poolId: 0,
      poolAddress: '0xb267DeaACe0B8c5FcB2bb04801A364e7Af7DA3F4',
      tokensLocked: '1761769.763428',
      totalValueLockedUSD: '42206.52',
      active: false,
      status: 'CLOSED',
      tokens: ['NTX', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 8453,
      name: 'Yield_SOPH_ETH_Base',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '13865696.160453046747838758',
      totalValueLockedUSD: '121376.32',
      active: true,
      status: 'OPEN',
      tokens: ['SOPH', 'ETH'],
      averageAPR: '109.5303',
    },
    {
      chainId: 1,
      name: 'Yield_SOPH_ETH',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xCe99861F0244D6478a309e2c2565FDaaAA8b0bFb',
      tokensLocked: '15799647.42739834877112239',
      totalValueLockedUSD: '138533.62',
      active: true,
      status: 'OPEN',
      tokens: ['SOPH', 'ETH'],
      averageAPR: '12.4658',
    },
    {
      chainId: 1,
      name: 'Yield_CGV_ETH',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x31Cd039D37DEe0C989cbE390F668fc38b033fB4f',
      tokensLocked: '17313.44025',
      totalValueLockedUSD: '265.27',
      active: false,
      status: 'CLOSED',
      tokens: ['CGV', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_CGV_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xB9892Aed8E49bf167Eb15D269777F6F5850aE450',
      tokensLocked: '1138466.903112',
      totalValueLockedUSD: '16894.11',
      active: false,
      status: 'CLOSED',
      tokens: ['CGV', 'BNB'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_HYPC_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x158a1d0144D8e5449305435DFaDEe07cd2dC85F4',
      tokensLocked: '5215.566576',
      totalValueLockedUSD: '395.96',
      active: false,
      status: 'CLOSED',
      tokens: ['HYPC', 'BNB'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_NTX_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xBa1933bc47e6Ad050A4E4485F6f4b16b9CcdB806',
      tokensLocked: '836508.733478',
      totalValueLockedUSD: '19272.95',
      active: false,
      status: 'CLOSED',
      tokens: ['NTX', 'BNB'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_RJV_BNB_OLD',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x93192A62008E25c33CBC3e60A00D27736b7b423F',
      tokensLocked: '630871.959784',
      totalValueLockedUSD: '7612.53',
      active: false,
      status: 'CLOSED',
      tokens: ['RJV', 'BNB'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_SDAO_USDT',
      type: 'YIELD',
      poolId: 3,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '66648.220462916658775431',
      totalValueLockedUSD: '6637.23',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO', 'USDT'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_SDAO_ETH',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '649220.225659076053314072',
      totalValueLockedUSD: '64323.25',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_AGIX_ETH',
      type: 'YIELD',
      poolId: 2,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '596959.12453022',
      totalValueLockedUSD: '348047.70',
      active: false,
      status: 'CLOSED',
      tokens: ['AGIX', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_AGIX_USDT',
      type: 'YIELD',
      poolId: 4,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '281534.39375973',
      totalValueLockedUSD: '164031.22',
      active: false,
      status: 'CLOSED',
      tokens: ['AGIX', 'USDT'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_SOPH_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xD8912300C2b96d9F2fb8f4a9cFea351Ebe2A696E',
      tokensLocked: '16513711.617763766927656185',
      totalValueLockedUSD: '141426.30',
      active: false,
      status: 'CLOSED',
      tokens: ['SOPH', 'BNB'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_SDAO_BUSD',
      type: 'YIELD',
      poolId: 2,
      poolAddress: '0x79292c62F593E08d9b850b790b07E7a0903fD007',
      tokensLocked: '37120.777325533968795536',
      totalValueLockedUSD: '3978.94',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO', 'BUSD'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_RJV_ETH_OLD',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x655E370104Ad4E4EE091b588aEc8A24156601Ca1',
      tokensLocked: '16408.294296',
      totalValueLockedUSD: '187.88',
      active: false,
      status: 'CLOSED',
      tokens: ['RJV_OLD', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_HYPC_ETH',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0xd1061Ff97c34835B90E3f8080e3AE2e5C8B38f1D',
      tokensLocked: '4950616.410166',
      totalValueLockedUSD: '377855.59',
      active: false,
      status: 'CLOSED',
      tokens: ['HYPC', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_DYNBTC_ETH',
      type: 'YIELD',
      poolId: 5,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '0',
      totalValueLockedUSD: '0.00',
      active: false,
      status: 'CLOSED',
      tokens: ['DYNBTC', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 1,
      name: 'Yield_DYNETH_ETH',
      type: 'YIELD',
      poolId: 6,
      poolAddress: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
      tokensLocked: '0',
      totalValueLockedUSD: '0.00',
      active: false,
      status: 'CLOSED',
      tokens: ['DYNETH', 'ETH'],
      averageAPR: '0.0000',
    },
    {
      chainId: 56,
      name: 'Yield_SDAO_BNB',
      type: 'YIELD',
      poolId: 1,
      poolAddress: '0x79292c62F593E08d9b850b790b07E7a0903fD007',
      tokensLocked: '193944.541494267084843779',
      totalValueLockedUSD: '20718.53',
      active: false,
      status: 'CLOSED',
      tokens: ['SDAO', 'BNB'],
      averageAPR: '0.0000',
    },
  ],
};

export type LegacyPositionCategory = keyof typeof VaultsLegacy;
export type LegacyPosition =
  (typeof VaultsLegacy)[LegacyPositionCategory][number];
export type LegacyPositionRow = LegacyPosition & {
  category: LegacyPositionCategory;
  id: string;
};

export const legacyPositionRows: LegacyPositionRow[] = Object.entries(
  VaultsLegacy
).flatMap(([category, positions]) =>
  positions.map((position) => ({
    ...position,
    category: category as LegacyPositionCategory,
    id: `${position.poolAddress}-${position.poolId}-${position.name}`,
  }))
);
